import { z } from "zod";
import { DM_SCOPE_VALUES, NOTIFICATION_RESOURCE_TYPE_VALUES, NOTIFICATION_TYPE_VALUES } from "../enum.js";

export const standardNotificationDataSchema = z.object({
	type: z.enum(NOTIFICATION_TYPE_VALUES),
	resource_id: z.string().optional(),
	resource_type: z.enum(NOTIFICATION_RESOURCE_TYPE_VALUES).optional(),
	group_id: z.string().optional(),
	conversation_id: z.string().optional(),
	scope: z.enum(DM_SCOPE_VALUES).optional(),
	author_id: z.string().optional(),
	actor_id: z.string().optional(),
	actor_first_name: z.string().optional(),
	actor_last_name: z.string().optional(),
	actor_photo_url: z.string().optional(),
	title: z.string().optional(),
	body: z.string().optional(),
});

export type StandardNotificationData = z.infer<typeof standardNotificationDataSchema>;
